import React from "react";
import { connect } from "react-redux";

import { subscribeToMailchimp, firestore } from "../../../firebase";
import * as actions from "../../../store/actions";

import classes from "./EmailSettings.module.css";
import Item from "./Item/Item";

const EmailSettings = ({ userId, email, mailchimpTags, setMailchimpTags }) => {
  const updateTags = (index, active) => {
    const newTags = [...mailchimpTags];
    if (active && newTags[index].status === "inactive") {
      newTags[index].status = "active";
      applyTags(newTags);
    } else if (!active && newTags[index].status === "active") {
      newTags[index].status = "inactive";
      applyTags(newTags);
    }
  };

  const applyTags = (tags) => {
    subscribeToMailchimp({
      email: email,
      tags: tags,
    }).catch((error) => {
      console.log(error);
    });
    setMailchimpTags(tags);
    firestore.collection("users").doc(userId).update({ mailchimpTags: tags });
  };

  return (
    <div className={classes.EmailSettings}>
      <h1>Email Settings</h1>
      <p style={{ marginBottom: "2em" }}>
        Edit your preferences about email notifications, decide which emails to
        receive, and sign up for the Art Prompts Newsletter.
      </p>
      <Item
        title="Updates about new prompts"
        description="Receive an informational email every time there are new prompts released in the web app. This usually happens every Friday."
        index={0}
        onChange={updateTags}
        tags={mailchimpTags}
      />
      <Item
        title="New features in Art Prompts"
        description="Receive emails about our updates, new features, wholly new branches, etc. These emails will come approximately once a month."
        index={1}
        onChange={updateTags}
        tags={mailchimpTags}
      />
      <Item
        title="Help improve Art Prompts"
        description="Receive occassional surveys about Art Prompts - your answers to will help us improve the project. These emails will come approximately once a month."
        index={2}
        onChange={updateTags}
        tags={mailchimpTags}
      />
      <h3>Get a daily prompt into your inbox</h3>
      <p>
        Sign up for the{" "}
        <a href="/newsletter" target="_blank">
          Art Prompts Newsletter
        </a>{" "}
        to receive a new prompt to your email, every day. The newsletter
        includes 2 exclusive prompts every week.
      </p>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userId: state.userId,
  email: state.email,
  mailchimpTags: state.mailchimpTags,
});

const mapDispatchToProps = (dispatch) => ({
  setMailchimpTags: (tags) => dispatch(actions.setMailchimpTags(tags)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailSettings);
